import { Box } from '@breathelife/mui';
import styled from '../../../../Styles/themed-styled-components';

import Typography from '../../../../Components/Typography';

export const MedicalInterviewView = styled(Box)`
  && {
    width: 100%;
  }
`;

export const JsonAreaHeaderContainer = styled(Box)`
  && {
    padding: 16px;
    border-bottom: 1px solid #e6e6e6;
    margin: 0;
  }
`;

export const JsonAreaHeaderElements = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const MedicalInterviewArea = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 0;
  height: calc(100% - 50px);
`;

export const MedicalInterviewTreeViewPanelContainer = styled.div`
  display: flex;
  border-right: 1px solid ${(props) => props.theme.colors.grey[40]};
  min-width: 56px;
  overflow: hidden;
  transition: all 0.5s linear;
  margin-left: 16px;
  height: 100%;
`;

export const MedicalInterviewTreeContainer = styled.div<{ width: number }>`
  display: flex;
  flex-direction: column;
  width: ${(props) => `${props.width}px`};
  transition:
    visibility 0.5s,
    opacity 0.5s,
    width 0.2s;
  padding: 16px 0;
  p {
    margin-left: 5px;
  }
`;

export const MedicalInterviewResizeHandle = styled.button<{ $isResizing: boolean }>`
  height: 100%;
  width: 1px;
  padding: 0px;
  border: 0px;
  background-color: transparent;
  cursor: ${(props) => (props.$isResizing ? 'col-resize' : 'ew-resize')};

  &:before {
    content: '';
    width: 2px;
    height: 100%;
    background-color: ${(props) => props.theme.colors.grey[40]};
    display: ${(props) => (props.$isResizing ? 'block' : 'none')};
  }

  &:hover {
    &:before {
      display: block;
    }
  }
`;

export const JsonAreaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const JsonViewerContainer = styled.div`
  background-color: #fbfbfb;
  flex-grow: 1;
`;

export const ApplicationInfoContainer = styled.div`
  display: flex;
`;
export const ApplicationTitle = styled(Typography)`
  && {
    margin-right: 6px;
  }
`;

export const XmlDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;

export const XmlHeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #f8f9fa;
`;

export const XmlContentContainer = styled.div`
  background-color: #fbfbfb;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 16px;
  margin: 16px;
  overflow-x: auto;
  max-height: 500px;
  overflow-y: auto;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 12px;
    line-height: 1.4;
    font-weight: normal !important;
  }

  /* Override any inherited font-weight */
  * {
    font-weight: normal !important;
  }
`;
